import { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

import { useWorkspace } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { GlobalStyle, defaultTheme, replaceColorsAndFontsInTheme } from '@treams/treams-ui';

interface IProps {
	children: ReactNode;
}

export default function BareLayout({ children }: IProps) {
	const workspace = useWorkspace();

	const { data: themeData } = graphql.useWorkspaceThemeQuery({
		variables: { id: workspace.id },
	});
	const theme = themeData
		? replaceColorsAndFontsInTheme(themeData.workspace.theme as graphql.WorkspaceTheme)
		: defaultTheme;

	return (
		<ThemeProvider theme={theme}>
			<GlobalStyle />
			{children}
		</ThemeProvider>
	);
}
